import {setButtonBusyState, unsetButtonBusyState} from "./spinners.js";
import {convertAjaxResponseErrorMessageToString, showValidationErrors} from "../../../admin/script/util/errors.js";
import {httpPost} from "../../util/http.js";

export class RegisterForm {

    constructor({$form, ...props}) {
        this.props = props;
        this.$form = $form;

        this.$form.on('input', 'input[name="user_type"]', e => {
            this.$form.find('.dynamic-show').addClass('d-none');
            this.$form.find('.show-only-for-' + e.target.value).removeClass('d-none');
        });

        this.$form.on('click', 'button[type="submit"]', e => {
            e.preventDefault();
            this.submit({
                $button: jQuery(e.target),
            });
        });

        this.$form.on('submit', e => {
            e.preventDefault();
            this.submit({
                $button: this.$form.find('button[type="submit"]'),
            });
        });
    }

    async submit(options = {}) {
        const $button = options.$button;
        const $registerFormElements = this.$form.find('.register-form-element');
        const data = {
            ...(options.data || {}),
            ...(this.props.data || {}),
        };

        $registerFormElements.each((i, element) => {
            if (element.name) {
                data[element.name] = element.value;
            }
        });

        data.rules = this.$form.find('input[name="rules"]').prop('checked');
        data.process_person_data = this.$form.find('input[name="process_person_data"]').prop('checked');
        data.marketing_consent = this.$form.find('input[name="marketing_consent"]').prop('checked');
        // data.user_type = this.$form.find('input[name="user_type"]:checked').val();

        setButtonBusyState($button);
        try {
            const userData = await httpPost(POLKURIER.paths.get('register_ajax'), data);
            this.hideErrors();
            showValidationErrors(this.$form, {});
            this.$form.html(
                jQuery('<div>', {class: 'alert alert-success'}).html(
                    '<strong>Gratulacje!</strong> Twoje konto na portalu POLKURIER.PL zostało założone. Na podany adres mailowy wysłaliśmy link aktywacyjny – kliknij w niego i zamów kuriera jeszcze dziś.'
                )
            );
            document.dispatchEvent(new CustomEvent('pk-register', {
                detail: userData,
            }));
        } catch (response) {
            this.showError(response.message || response.responseJSON.errors || 'Formularz zawiera błędy');
            if (response.responseJSON.data && response.responseJSON.data.fieldsErrors) {
                showValidationErrors(this.$form, response.responseJSON.data.fieldsErrors);
            }
        }
        unsetButtonBusyState($button);
    }

    hideErrors() {
        this.$form.find('.is-invalid').removeClass('is-invalid');
        this.$form.find('.errors-container').hide();
    }

    showError(message) {
        this.$form.find('.errors-container')
            .empty()
            .show()
            .append([
                jQuery('<div>', {class: 'alert alert-danger text-center mb-3'})
                    .append([
                        message,
                    ]),
            ]);
    }

}
